import { createGtm, useGtm } from '@gtm-support/vue-gtm'

interface Args {
  event?: string
  [key: string]: unknown
}

export const useGtmTrack = () => {
  const $gtm = useGtm()

  return {
    getGtmDataLayerVariableVersion2,
    trackEvent,
    createGtm,
    $gtm,
  }
}

function trackEvent(args: Args) {
  const { isPreview } = useBaseRoutes()
  const $gtm = useGtm()

  if (!$gtm?.enabled() || isPreview.value) {
    return
  }

  const { event, ...arg } = args
  const obj = {
    ...arg,
  }

  if (event) {
    obj.event = event
  }

  window.dataLayer?.push(obj)
}

export interface CurrentUser {
  id: string
  isEmployee: boolean
  age: number
  cardNumber: string
  emailSHA256: string
  emailMD5: string
  mobileNumberMD5: string
  loyaltyPoints: number
  loyaltyTier: string
  tierPointsCounter: number
}

function getGtmDataLayerVariableVersion2(currentUser = {} as CurrentUser) {
  const { countryCode, getCurrentLocale } = useI18nLocale()
  const { isMobile } = useDevice()

  const variableVersion2 = {
    user: {
      id: currentUser?.id || '',
      is_employee: currentUser?.isEmployee || false,
      age: currentUser?.age || 0,
      card_number: currentUser?.cardNumber || '',
      email_sha256: currentUser?.emailSHA256 || '',
      email_md5: currentUser?.emailMD5 || '',
      mobile_number_md5: currentUser?.mobileNumberMD5 || '',
      loyalty_points: currentUser?.loyaltyPoints || 0,
      loyalty_tier: currentUser?.loyaltyTier || '',
      tier_points_counter: currentUser?.tierPointsCounter || 0,
    },
    cart: {},
    site: {
      locale: countryCode.toLowerCase(),
      language: getCurrentLocale(),
      mobile: isMobile,
      status: 200,
    },
  }

  return variableVersion2
}
